import { render, staticRenderFns } from "./OrderDineInSideBar.vue?vue&type=template&id=46dfa8f2"
import script from "./OrderDineInSideBar.vue?vue&type=script&lang=js"
export * from "./OrderDineInSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports